// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"12":"66436dea","969":"184e3095"}[chunkId] + ".chunk.css";
};